<template>
    <div>
        <div class="stay-container">
            <div class="card-wrapper">
                <div class="card-title-wrapper">
                    <div class="card-title">
                        <h1>Leave without saving?</h1>
                        <h3 class="card-subtitle">
                            There are unsaved changes on this page. Are you sure you want to exit and
                            discard your changes?
                        </h3>
                    </div>

                </div>
                <div class="bottom-btn">
                    <button @click="confirm" class="card-btn leave-btn">
                        Leave this page
                    </button>
                    <button @click="cancel" class="card-btn">
                        Stay on this page
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {

    methods: {
        // updateState() {
        //     this.$store.commit('onboarding/setModuleAvailableModal', false);
        // },
        // closeModal() {
        //     this.$store.commit('onboarding/setStayReminderModal', false)
        // },
        // backToOnboarding() {
        //     this.$store.commit('onboarding/setStayReminderModal', false)
        //     this.$store.commit('onboarding/setPayoutRequirementsBack', true)
        //     this.$router.push("/onboarding")
        // }
        confirm() {
            this.$emit('confirm'); // Emit event when confirming
        },
        cancel() {
            this.$emit('cancel'); // Emit event when canceling
        }
    },
}
</script>
<style lang="scss" scoped>
.stay-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
}

.card-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    background-color: #FFF;
    width: 401px;

}

.card-subtitle {
    color: #49545C;
    font-family: MainFontRegular, sans-serif;
    font-size: 13px;
    font-style: normal;
    line-height: 22px;


}

.card-title {
    margin-top: 20px;
    margin-left: 25px;

    h1 {
        font-family: MainFontRegular, sans-serif;
        font-size: 15px;
        line-height: 22px;
        letter-spacing: 0px;
        text-align: left;
        margin-bottom: 20px;
        color: #2F3941;


    }
}

.card-btn {
    border-radius: 8px;
    background: #53B6B2;
    display: flex;
    height: 40px;
    padding: 15px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    color: #FFF;
    font-family: MainFontRegular, sans-serif;
    font-size: 14px;
    font-style: normal;
    line-height: normal;
    border: none;

    transition: opacity 0.3s;
    /* Add a transition for smooth effect */

    &:active {
        opacity: 0.5;
    }
}

.leave-btn {
    margin-right: 8px;
    background-color: #fff;
    color: #68737D;
    border: solid 1px #87929D;
}

.bottom-btn {
    padding-top: 8px;
    display: flex;
    justify-content: end;
    align-items: center;
    width: 100%;
    border-top: 1px #E9EBED solid;
    padding-bottom: 12px;
    padding-right: 11px;
}
</style>